var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgManageStation = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4499 10.7567C21.3383 10.7567 20.4749 9.26333 21.5249 7.43166C22.1316 6.37 21.7699 5.01666 20.7083 4.41L18.6899 3.255C17.7683 2.70666 16.5783 3.03333 16.0299 3.955L15.9016 4.17666C14.8516 6.00833 13.1249 6.00833 12.0633 4.17666L11.9349 3.955C11.4099 3.03333 10.2199 2.70666 9.29825 3.255L7.27992 4.41C6.21825 5.01666 5.85659 6.38166 6.46325 7.44333C7.52492 9.26333 6.66159 10.7567 4.54992 10.7567C3.33659 10.7567 2.33325 11.7483 2.33325 12.9733V15.0267C2.33325 16.24 3.32492 17.2433 4.54992 17.2433C6.66159 17.2433 7.52492 18.7367 6.46325 20.5683C5.85659 21.63 6.21825 22.9833 7.27992 23.59L9.29825 24.745C10.2199 25.2933 11.4099 24.9667 11.9583 24.045L12.0866 23.8233C13.1366 21.9917 14.8633 21.9917 15.9249 23.8233L16.0533 24.045C16.6016 24.9667 17.7916 25.2933 18.7133 24.745L20.7316 23.59C21.7933 22.9833 22.1549 21.6183 21.5483 20.5683C20.4866 18.7367 21.3499 17.2433 23.4616 17.2433C24.6749 17.2433 25.6783 16.2517 25.6783 15.0267V12.9733C25.6666 11.76 24.6749 10.7567 23.4499 10.7567ZM13.9999 17.7917C11.9116 17.7917 10.2083 16.0883 10.2083 14C10.2083 11.9117 11.9116 10.2083 13.9999 10.2083C16.0883 10.2083 17.7916 11.9117 17.7916 14C17.7916 16.0883 16.0883 17.7917 13.9999 17.7917Z",
    fill: "url(#paint0_linear_640_6457)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_640_6457",
    x1: 2.33325,
    y1: 12.3482,
    x2: 25.6783,
    y2: 12.3482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgManageStation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/manageStation.e347b139.svg";
export { ForwardRef as ReactComponent };